import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date'
import {
  Box,
  Button,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { useEffect, useState } from 'react'
import { RootStateOrAny, useSelector } from 'react-redux'
import styled from 'styled-components'
import { fetchReports } from '../../modules/reporting'
import { useAppDispatch } from '../../store'
import Datepicker from '../Form/Datepicker'
import FormContainer from '../Form/FormContainer'
import Loader from '../Loader/Loader'
import Message from '../Message/Message'

const DateRangeContainer = styled(Box)`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 32px;
  margin-left: -24px;
  align-items: flex-end;

  p {
    margin-bottom: 8px;
  }
`

const Reporting = () => {
  const dispatch = useAppDispatch()

  const { loading, error, data } = useSelector(
    (state: RootStateOrAny) => state.reporting
  )

  const currentDate = new Date()
  const pastDate = new Date(currentDate).setDate(currentDate.getDate() - 31)

  const [start, setStart] = useState<MaterialUiPickersDate>(new Date(pastDate))
  const [end, setEnd] = useState<MaterialUiPickersDate>(currentDate)

  const handleSubmit = () => {
    dispatch(fetchReports(start, end))
  }

  useEffect(() => {
    // Fetch reports once on mount
    dispatch(fetchReports(start, end))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  useEffect(() => {
    if (end && start) {
      let newStartDate = start

      // If the end date is before the start date, set the start date to the day before the end date
      if (end.getTime() < start?.getTime()) {
        newStartDate = new Date(end)
        newStartDate.setDate(end.getDate() - 1)
      }
    }
  }, [end, start])

  return (
    <div className="library gray-bg">
      <Container className="p-b-100">
        <h3 className="page-title accent-left">Reporting</h3>

        <FormContainer>
          <DateRangeContainer>
            <Box sx={{ mr: 3 }}>
              <p className="m-r-16">Start Date</p>
              <Datepicker
                value={start}
                setValue={setStart}
                className="m-t-0 m-b-0"
                disablePast={false}
                disableFuture={true}
              />
            </Box>

            <Box>
              <p className="m-r-16">End Date</p>
              <Datepicker
                value={end}
                setValue={setEnd}
                className="m-t-0 m-b-0"
                disablePast={false}
                disableFuture={true}
              />
            </Box>

            <Button
              color="primary"
              variant="contained"
              sx={{ height: 36, ml: 3, mb: '1px' }}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </DateRangeContainer>
        </FormContainer>

        <div className="flex flex-end m-b-16">
          {loading && <Loader />}

          {error && <Message variant="error">{error}</Message>}

          {!loading && !error && (
            <TableContainer>
              <Table stickyHeader aria-label="reporting table">
                <TableHead>
                  <TableRow>
                    <TableCell>Close Won</TableCell>
                    <TableCell>Close Lost</TableCell>
                    <TableCell>Submitted</TableCell>
                    <TableCell>Unconverted</TableCell>
                    <TableCell>Unassigned</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>{data.closeWon}</TableCell>
                    <TableCell>{data.closeLost}</TableCell>
                    <TableCell>{data.submitted}</TableCell>
                    <TableCell>{data.unconverted}</TableCell>
                    <TableCell>{data.unassigned}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </div>
      </Container>
    </div>
  )
}

export default Reporting
